import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { postData } from "../../../services/generalService";
import { PostDisbursalTransactionalObj } from "../../../utils/types";

const initialState: PostDisbursalTransactionalObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const postDisbursalTransaction = createAsyncThunk(
  "loans/postDisbursalTransaction",
  async (formData: { url: string; postsData: {} }, thunkAPI) => {
    const { url, postsData } = formData;
    try {
      const data = await postData(url, postsData, true);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const postDisbursalTransactionSlice = createSlice({
  name: "postDisbursalTransaction",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(postDisbursalTransaction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postDisbursalTransaction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(postDisbursalTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default postDisbursalTransactionSlice.reducer;
